<template>
	<h1 style="text-align: center;margin-top: 100px;">Запрашиваемая страница не существует</h1>
</template>
<script>
  export default {
    name: "Page404"
  }
</script>
